export const updatePhone = (currentCode: string, prevCode: string, phone: string) => (`${currentCode}${phone.slice(prevCode.length)}`);
